// |0----xs----375----sm----768----md----1024----lg----1440----xl----1920|
enum ViewPortSizes {
  SMALL = 375,
  MEDIUM = 768,
  LARGE = 1024,
  XLARGE = 1440,
}

enum Breakpoints {
  XS = 'xs', //small mobile
  SM = 'sm', //mobile
  MD = 'md', //tablet
  LG = 'lg', //desktop
  XL = 'xl', //large desktop
}

export { ViewPortSizes, Breakpoints };
